
var lib_geometry = require("lib-geometry");
var TextMeshHelper = require("./textMeshHelper");

var TextToMesh = function(){

    this.mesh = this.deepCachedFunction("mesh", 
        function(info){
            var silkscreenHeight = (info && info.silkscreenHeight)? info.silkscreenHeight : 1;
            var silkscreenEndSegments = (info && info.silkscreenEndSegments)? info.silkscreenEndSegments : 3;
            var holes = (info && info.holes)? info.holes : [];
            var boardThickness = (info && info.boardThickness)? info.boardThickness : 2;

            var mesh = TextMeshHelper(this, holes, silkscreenHeight, silkscreenEndSegments);

            var layeredShapeData = this.parent().layerIndex ? this.parent() : this.parent().parent();   // TODO: not very clean!! (fix for property data
            if(layeredShapeData && layeredShapeData.layerIndex.contains(1)){
                mesh.translate(0,0, -boardThickness - silkscreenHeight);
            }

            return mesh;

        },
        [this.text, this.traces, this.pos, this.angle, this.strokeWidth], 1
    );
}
 

module.exports = TextToMesh;